<template>

  <div class="about-page">
    <Header></Header>
    <section v-if="artist" class="artist-detail-hero-section background-fit" :style="{ backgroundImage: `url(${artistBg})` }"></section>

    <section class="artist-detail-section" v-if="artist">
      <div class="container">
        <div class="row row-1">
          <div class="col-md-2">
            <div class="artist-img background-fit" v-if="artist.profiles[0].images[0].profileImageFile" :style="{ backgroundImage: `url(${imageUrl + artist.profiles[0].images[0].profileImageFile})` }"></div>
            <div class="artist-img background-fit artist-dummy-stage" v-if="!artist.profiles[0].images[0].profileImageFile" :style="{ backgroundImage: `url(${backgroundUrl2})` }"></div>
          </div>
          <div class="col-md-6">
            <div class="ar-detail">
              <h3>{{artist.name}}</h3>
              <h4 v-if="artist.profiles[0].profession">{{artist.profiles[0].profession}}</h4>
              <h4 v-if="!artist.profiles[0].profession">No Profession</h4>
            </div>
            <p v-if="artist.profiles[0].bio">{{artist.profiles[0].bio}}</p>
            <p v-if="!artist.profiles[0].bio">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis. Suspendisse urna nibh, viverra non, semper suscipit, posuere a, pede.Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio.</p>
          </div>
          <div class="col-md-4">
            <h4 v-if="artist.profiles[0].skills && artist.profiles[0].skills.length">Skills</h4>
            <p v-if="artist.profiles[0].skills && artist.profiles[0].skills.length">
              <span v-if="artist.profiles[0].skills" class="skills" v-for="(skill) in artist.profiles[0].skills" v-bind:key="skill.id">{{skill}}<i>, </i> </span>
              <span v-if="!artist.profiles[0].skills" class="skills">No skills </span>
            </p>
            <h4 v-if="artist.profiles[0].college">Education</h4>
            <p>
              <span v-if="artist.profiles[0].college" class="skills">{{artist.profiles[0].college}}</span><br/>
              <span v-if="artist.profiles[0].college" class="skills">{{artist.profiles[0].degree}}</span><br/>
              <span v-if="artist.profiles[0].college" class="skills">{{artist.profiles[0].passoutyear}}</span>
            </p>
            <h4 v-if="artist.profiles[0].location">Location</h4>
            <p v-if="artist.profiles[0].location">{{artist.profiles[0].location}}</p>
          </div>
          <div class="col-md-10">
            <ul class="list-inline mt-4">
              <li>
                <Chat v-if="!myProfileFlag" :data="artist" />
                <!--<router-link :to="`/artists/`+artist._id+`/message`" class="view-profile" v-if="!myProfileFlag">SEND MESSAGE</router-link>-->
                <router-link class="view-profile" v-if="myProfileFlag" to="/accounts-detail">EDIT PROFILE</router-link>
              </li>
              <li v-if="instagramContact">
                <a :href="instagramContact" target="_blank"><img src="@/assets/img/media/instagram.svg"/></a>
              </li>
              <li v-if="twitterContact">
                <a :href="twitterContact" target="_blank"><img src="@/assets/img/media/twitter.svg"/></a>
              </li>
              <li v-if="youtubeContact">
                <a :href="youtubeContact" target="_blank"><img src="@/assets/img/media/youtube.svg" style="width: 38px;" /></a>
              </li>
              <li v-if="facebookContact">
                <a :href="facebookContact" target="_blank"><img src="@/assets/img/media/facebook.svg"/></a>
              </li>
              <li v-if="websiteContact">
                <a :href="websiteContact" target="_blank"><img src="@/assets/img/media/globe.svg"/></a>
              </li>
              <li v-if="emailIdContact">
                <a :href="emailIdContact" target="_blank"><img src="@/assets/img/media/email.svg"/></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="adl-section" v-if="artist" style="padding-bottom: 100px;">
      <div class="container">
        <div class="row">
          <div class="col-md-6 fc-col background-fit"  :style="{ backgroundImage: `url(${imageUrl + list.videoId[0].videoImageFile})` }" v-for="(list) in artist.stages" v-bind:key="list._id">
            <router-link class="edit-stage" v-if="myProfileFlag" :to="`/stage/` + list._id + `/edit/`"><img src="@/assets/img/edit-icon.png" width="50" /></router-link>
            <router-link class="inner-blk" :to="`/stage/` + list._id">
              <div class="i-blk">
                <div class="a-detail">
                  <h3>{{list.title}}</h3>
                  <p>{{list.created | formatDate}}</p>
                  <span><img src="@/assets/img/next-arrow.svg"/></span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="adl-section gallery-section" v-if="lists.length" style="padding-bottom: 100px;">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>Gallery</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 fc-col background-fit"  :style="{ backgroundImage: `url(${imageUrl + list.galleryImage})` }" v-for="(list) in lists" v-bind:key="list.id">
            <a href="#" data-toggle="modal" :data-image="imageUrl + list.galleryImage" data-target="#galleryModal" v-on:click="galleryFunction" class="inner-blk gallery-blk">

            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="fc-section pb-5" style="background-color: #FFFFFF;" v-if="videos">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>Campaign Videos</h2>
          </div>
        </div>
        <div class="row">
          <div v-if="(list.imagePath && list.videoPath && list.featured) || (list.imagePath && list.youtube && list.featured)" class="col-md-4 fc-col background-fit" :style="{ backgroundImage: `url(${imageUrl + list.imagePath})` }" v-for="(list) in videos" v-bind:key="list.id">
            <div class="inner-blk">
              <div class="i-blk">
                <router-link :to="`/artists/`+list.artistId._id" class="profile-p background-fit" :style="{ backgroundImage: `url(${imageUrl + list.artistId.profiles[0].images[0].profileImageFile})` }"></router-link>
                <div class="p-detail">
                  <h3>{{list.title}}</h3>
                  <p>{{list.created | formatDate}}</p>
                  <span data-toggle="modal" v-on:click="playVideo(imageUrl + list.videoPath, imageUrl + list.imagePath, list.youtube)" data-target="#showVideo"><img src="@/assets/img/next-arrow-white.svg" width="40" /></span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="(list.imagePath && list.videoPath && !list.featured) || (list.imagePath && list.youtube && !list.featured)" class="col-md-4 fc-col background-fit" :style="{ backgroundImage: `url(${imageUrl + list.imagePath})` }" v-for="(list) in videos" v-bind:key="list.id">
            <div class="inner-blk">
              <div class="i-blk">
                <router-link :to="`/artists/`+list.artistId._id" class="profile-p background-fit" :style="{ backgroundImage: `url(${imageUrl + list.artistId.profiles[0].images[0].profileImageFile})` }"></router-link>
                <div class="p-detail">
                  <h3>{{list.title}}</h3>
                  <p>{{list.created | formatDate}}</p>
                  <span data-toggle="modal" v-on:click="playVideo(imageUrl + list.videoPath, imageUrl + list.imagePath, list.youtube)" data-target="#showVideo"><img src="@/assets/img/next-arrow-white.svg" width="40" /></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Modal -->
    <div class="modal fade" id="galleryModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img :src="galleryImage" class="gallery-modal-image"/>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="showVideo" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding-top: 0">
            <video-player v-if="videoFlag"  class="video-player-box stg-detail-i"
                          ref="videoPlayer"
                          :options="playerOptions"
                          :playsinline="true"
                          customEventName="customstatechangedeventname"

                          @play="onPlayerPlay($event)"
                          @pause="onPlayerPause($event)"
                          @statechanged="playerStateChanged($event)"
                          @ready="playerReadied">
            </video-player>
            <iframe style="width: 100%;height:400px;" v-if="youtubeFlag" :src="`https://www.youtube.com/embed/`+youtube" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import router from '../router'
import $ from "jquery"
import backgroundUrl from '@/assets/img/image6.jpg'
import backgroundUrl2 from '@/assets/img/image1.jpg'
import backgroundUrl1 from '@/assets/img/team/dasha.png'
import backgroundUrl4 from '@/assets/img/image4.jpg'
import backgroundUrl5 from '@/assets/img/image5.svg'
import artistBackground from '@/assets/img/profile_bg.jpg'
import axios from 'axios'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import Chat from "./include/Chat";

Vue.use(VueHead)
Vue.use(VueRouter)

export default {
  name: 'ArtistDetail',
  components: {
      Chat,
    'Header': Header,
    'Footer': Footer,
      videoPlayer
  },
  mounted () {
      if(this.userData && (this.userData.user.id == this.artistId)){
          this.myProfileFlag = true
      }
      var $this = this
      $('#showVideo').on('hidden.bs.modal', function () {
          if($this.youtubeFlag){
              $this.youtubeFlag = false
          } else {
              $this.videoFlag = false
          }
      })
      this.getGallery()
      this.getCampaignVideos()
      axios
          .get('/getartistdetail', {
              params: {
                  artistId: this.artistId,
                  role: 'artist'
              }
          })
          .then(response => {
              // this.artist = response.data.user

              let allStages = []
              let allStagesId = []
              if(response.data.user.stages.length && response.data.role.length){
                  $.each(response.data.user.stages, function (key, value) {
                      allStagesId.push(value._id)
                  })
                  $.each(response.data.role, function (key, value) {
                      if(!allStagesId.includes(value.stageId._id)){
                          response.data.user.stages.push(value.stageId)
                      }
                  })
              } else if(!response.data.user.stages.length && response.data.role.length){
                  $.each(response.data.role, function (key, value) {
                      response.data.user.stages.push(value.stageId)
                  })
              }

              this.artist = response.data.user
              if(this.artist.profiles[0].images[0].bgImageFile){
                  this.artistBg = this.imageUrl + this.artist.profiles[0].images[0].bgImageFile
              }

              this.facebookContact = this.artist.profiles[0].facebookContact
              this.twitterContact = this.artist.profiles[0].twitterContact
              this.instagramContact = this.artist.profiles[0].instagramContact
              this.youtubeContact = this.artist.profiles[0].youtubeContact
              this.websiteContact = this.artist.profiles[0].websiteContact
              this.emailIdContact = this.artist.profiles[0].emailIdContact

              if(this.facebookContact && !this.facebookContact.includes('facebook.com')){
                  this.facebookContact = 'https://www.facebook.com/'+this.facebookContact
              }
              if(this.twitterContact && !this.twitterContact.includes('twitter.com')){
                  this.twitterContact = 'https://twitter.com/'+this.twitterContact
              }
              if(this.instagramContact && !this.instagramContact.includes('instagram.com')){
                  this.instagramContact = 'https://www.instagram.com/'+this.instagramContact
              }
              if(this.youtubeContact && !this.youtubeContact.includes('youtube.com/channel')){
                  this.youtubeContact = 'https://www.youtube.com/channel/'+this.youtubeContact
              }
          })
          .catch(error => console.log(error))
  },
    computed: {
        player() {
            return this.$refs.videoPlayer.player
        }
    },
    methods: {
        playVideo: function (video, image, youtube){
            if(youtube && youtube.includes('youtube')){
                let uri = youtube.split('?')
                if (uri.length == 2)
                {
                    let vars = uri[1].split('&')
                    let getVars = {}
                    let tmp = ''
                    vars.forEach(function(v){
                        tmp = v.split('=')
                        if(tmp.length == 2)
                            getVars[tmp[0]] = tmp[1]
                    })
                    this.youtubeFlag = true
                    this.youtube = getVars.v
                    // do
                }
            } else {
                this.videoFlag = true
                this.playerOptions = {
                    muted: false,
                    language: 'en',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [{
                        type: "video/mp4",
                        src: video
                    }],
                    poster: image
                }
            }
        },
        // listen event
        onPlayerPlay(player) {
            console.log('player play!', player)
        },
        onPlayerPause(player) {
            console.log('player pause!', player)
        },
        // ...player event

        // or listen state event
        playerStateChanged(playerCurrentState) {
            console.log('player current update state', playerCurrentState)
        },

        // player is ready
        playerReadied(player) {
            console.log('the player is readied', player)
            // you can use it to do something...
            // player.[methods]
        },
        galleryFunction: function (event) {
            this.galleryImage = event.target.dataset.image
        },
        getGallery: function(){
            axios
                .get('/getGallery', {
                    params: {
                        artistId: this.artistId
                    }
                })
                .then(response => {
                    this.lists = response.data
                })
                .catch(error => {
                    Vue.$toast.open(
                        {
                            message: error.response.data,
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                })
        },
        getCampaignVideos: function (event) {
            axios
                .get('/getSixFeetApartVideosById', {
                    params: {
                        artistId: this.artistId
                    }
                })
                .then(response => {
                    if(response.data.length){
                        this.videos = response.data
                    }
                    this.playerOptions = {
                        muted: false,
                        language: 'en',
                        playbackRates: [0.7, 1.0, 1.5, 2.0],
                        sources: [{
                            type: "video/mp4",
                            src: ''
                        }],
                        poster: this.imageName
                    }

                })
                .catch(error => console.log(error))
        }
    },
  data () {
      var userdata = localStorage.getItem('cbs_usertoken')
      if(userdata){
          userdata = JSON.parse(userdata)
      }
    return {
        backgroundUrl: backgroundUrl,
        backgroundUrl1: backgroundUrl1,
        backgroundUrl2: backgroundUrl2,
        backgroundUrl4: backgroundUrl4,
        backgroundUrl5: backgroundUrl5,
        imageUrl: process.env.imageUrl,
        myProfileFlag: false,
        list: '',
        lists: '',
        userData: userdata,
        artistBg: artistBackground,
        galleryImage: artistBackground,
        artistId: router.history.current.params.id,
        msg: 'Welcome to Your Vue.js App',
        artist: '',
        stages: '',
        title: 'Title goes here',
        videos: '',
        youtubeFlag: false,
        videoFlag: false,
        youtube: '',
        facebookContact: '',
        twitterContact: '',
        instagramContact: '',
        youtubeContact: '',
        websiteContact: '',
        emailIdContact: '',
        playerOptions: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ArtistDetail.vue